export const trip_object = {
  get_id: '', //string
  item_id: '', //string
  display_name: '', //string
  item_type: '', //string
  name: '', //string
  address: {
    city: '', //string
    country: '', //string
    country_code: '', //string
    continent: '', //string
  },
  description: '', //string
  images: [{}],
  share_url: '', //string
  vendor_id: '', //string
  properties: {
    price: [
      {
        text: '', //string
        type: '', //string
        unit: '', //string
        value: 0, //number
      },
    ],
    theme: '', //string
    trip_summary: {
      pace: '', //string
      duration_days: 0, //number
      activity_count: 0, //number
      attraction_count: 0, //number
      start_date: '', //string
      end_date: '', //string
    },
    influencer_flag: true, //boolean
    tags: [
      '', //string
    ],
    guest_info: [
      {
        no_of_adults: 0, //number
        no_of_children: 0, //number
        children_ages: [{}],
      },
    ],
    base_currency: '', //string
    star_rating: 0, //number
    stay_awards: [
      '', //string
    ],
    redirect_url: '', //string
    redirect_text: '', //string
    review_summary: [
      {
        tag: '', //string
        source: '', //string
        max_rating: 0, //number
        review_count: 0, //number
        review_rating: 0, //number
      },
    ],
    primary_sub_category: '', //string
    review: {
      reviews: 0, //number
      avg_review: 0, //number
      provider_name: '', //string
      provider_icon_url: '', //string
    },
    languages: '', //string
    duration_min: 0, //number
    refund_condition_condensed: '', //string
    open_hours: [
      '', //string
    ],
    attraction_type: {},
  },
  location: {
    latitude: 0, //number
    longitude: 0, //number
  },
  intro: {
    title: '', //string
    videos: [{}],
  },
  curator_info: {},
  destination_info: {
    destination_id: '', //string
    trip_available: true, //boolean
    activity_available: true, //boolean
    vacation_home_available: true, //boolean
  },
  trip_days: [
    {
      day: 0, //number
      pace: '', //string
      itinerary_items: [
        {
          item_id: '', //string
          display_name: '', //string
          item_type: '', //string
          name: '', //string
          address: {
            city: '', //string
            country: '', //string
            country_code: '', //string
            continent: '', //string
          },
          description: '', //string
          images: [{}],
          location: {
            latitude: 0, //number
            longitude: 0, //number
          },
          curator_info: {},
          destination_info: {
            destination_id: '', //string
            trip_available: true, //boolean
            activity_available: true, //boolean
            vacation_home_available: true, //boolean
          },
          vendor_id: '', //string
          properties: {
            price: [
              {
                text: '', //string
                type: '', //string
                unit: '', //string
                value: 0, //number
              },
            ],
            theme: '', //string
            trip_summary: {
              pace: '', //string
              duration_days: 0, //number
              activity_count: 0, //number
              attraction_count: 0, //number
              start_date: '', //string
              end_date: '', //string
            },
            influencer_flag: true, //boolean
            tags: [
              '', //string
            ],
            guest_info: [
              {
                no_of_adults: 0, //number
                no_of_children: 0, //number
                children_ages: [{}],
              },
            ],
            base_currency: '', //string
            star_rating: 0, //number
            stay_awards: [
              '', //string
            ],
            redirect_url: '', //string
            redirect_text: '', //string
            review_summary: [
              {
                tag: '', //string
                source: '', //string
                max_rating: 0, //number
                review_count: 0, //number
                review_rating: 0, //number
              },
            ],
            primary_sub_category: '', //string
            review: {
              reviews: 0, //number
              avg_review: 0, //number
              provider_name: '', //string
              provider_icon_url: '', //string
            },
            languages: '', //string
            duration_min: 0, //number
            refund_condition_condensed: '', //string
            open_hours: [
              '', //string
            ],
            attraction_type: {},
          },
          day: 0, //number
          day_part: '', //string
          duration_min: 0, //number
          end_time: '', //string
          intro: {},
          linked_items: {
            available: 0, //number
            price: [
              {
                text: '', //string
                type: '', //string
                unit: '', //string
                value: 0, //number
              },
            ],
            items: [
              {
                item_id: '', //string
                display_name: '', //string
                item_type: '', //string
                name: '', //string
                address: {
                  city: '', //string
                  country: '', //string
                  country_code: '', //string
                  continent: '', //string
                },
                description: '', //string
                images: [{}],
                location: {
                  latitude: 0, //number
                  longitude: 0, //number
                },
                curator_info: {},
                destination_info: {
                  destination_id: '', //string
                  trip_available: true, //boolean
                  activity_available: true, //boolean
                  vacation_home_available: true, //boolean
                },
                vendor_id: '', //string
                properties: {
                  price: [
                    {
                      text: '', //string
                      type: '', //string
                      unit: '', //string
                      value: 0, //number
                    },
                  ],
                  theme: '', //string
                  trip_summary: {
                    pace: '', //string
                    duration_days: 0, //number
                    activity_count: 0, //number
                    attraction_count: 0, //number
                    start_date: '', //string
                    end_date: '', //string
                  },
                  influencer_flag: true, //boolean
                  tags: [
                    '', //string
                  ],
                  guest_info: [
                    {
                      no_of_adults: 0, //number
                      no_of_children: 0, //number
                      children_ages: [{}],
                    },
                  ],
                  base_currency: '', //string
                  star_rating: 0, //number
                  stay_awards: [
                    '', //string
                  ],
                  redirect_url: '', //string
                  redirect_text: '', //string
                  review_summary: [
                    {
                      tag: '', //string
                      source: '', //string
                      max_rating: 0, //number
                      review_count: 0, //number
                      review_rating: 0, //number
                    },
                  ],
                  primary_sub_category: '', //string
                  review: {
                    reviews: 0, //number
                    avg_review: 0, //number
                    provider_name: '', //string
                    provider_icon_url: '', //string
                  },
                  languages: '', //string
                  duration_min: 0, //number
                  refund_condition_condensed: '', //string
                  open_hours: [
                    '', //string
                  ],
                  attraction_type: {},
                },
                day_part: '', //string
                intro: {},
                is_default: true, //boolean
              },
            ],
          },
          metadata: {},
          order: 0, //number
          pace: '', //string
          start_time: '', //string
          transit_duration_min: 0, //number
          notes: [
            {
              icon_name: '', //string
              type: '', //string
              display_name: '', //string
              value: '', //string
              order: 0, //boolean
            },
          ],
          booking_info: {
            booking_status: '', //string
            booking_details: {},
            price: [{}],
            voucher_url: {},
            booking_reference: {},
          },
          is_default: true, //boolean
        },
      ],
      neighbourhood_info: {
        id: '', //string
        item_type: '', //string
        is_default: 0, //number
        name: '', //string
        display_name: '', //string
        image: {},
        notes: [
          {
            icon_name: '', //string
            type: '', //string
            display_name: '', //string
            value: '', //string
            order: 0, //number
          },
        ],
      },
      date: '', //string
    },
  ],
  customer_info: {
    name: '', //string
    email: '', //string
    phone: '', //string
    country_code: '', //string
  },
  user_id: 0, //number
  trip_status: '', //string
  vendor_properties: {
    id: 0, //number
    name: '', //string
    display_name: '', //string
    icon_url: '', //string
  },
  is_default: true, //boolean
}
